import React from 'react';
import PropTypes from 'prop-types';
import { BlockDataForm } from '@plone/volto/components/manage/Form';
import { SidebarPortal } from '@plone/volto/components';
import Schema from './schema';
import PassosView from './View';

/** Edit do Passo a passo: o desenho do View e os passos na barra lateral. */
const PassosEdit = ({ data, onChangeBlock, block, selected }) => {
  const schema = Schema();
  return (
    <>
      <PassosView
        data={data}
        vazio={
          <p className="ag-passos__vazio">
            Passo a passo: adicione os passos na barra lateral.
          </p>
        }
      />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id, value) =>
            onChangeBlock(block, { ...data, [id]: value })
          }
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

PassosEdit.propTypes = {
  data: PropTypes.object.isRequired,
  onChangeBlock: PropTypes.func.isRequired,
  block: PropTypes.string.isRequired,
  selected: PropTypes.bool,
};

export default PassosEdit;
